<template>
  <div>
    <p id="dashboardItemTitle">Declined</p>
    <div style="margin-top: 30px">

      <section v-if="!isLoading">

        <template v-if="tableRows.length < 1" >
          <div class="empty-indicator">
            <span class="icon has-text-grey-lighter is-normal">
                <i class="mdi mdi-information-outline mdi-24px"></i>
            </span>
            <span class="ml-2 has-text-grey-lighter">No records to display</span>
          </div>
        </template>
        <b-table
            v-else
            :data="tableRows"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page="currentPage"
            :pagination-simple="isPaginationSimple"
            :pagination-position="paginationPosition"
            :default-sort-direction="defaultSortDirection"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            :hoverable="isHoverable"
            :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :sticky-header="stickyHeaders"

            pagination-size="is-small"
            default-sort="reference_id"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">


          <b-table-column field="document_crated_by" label="Created By" width="120" sortable v-slot="props" centered>
            {{ props.row.document_crated_by }}
          </b-table-column>

          <b-table-column field="document_name" label="Title" sortable v-slot="props" centered>
            {{ props.row.document_name }}
          </b-table-column>

          <b-table-column field="document_status" label="Status" sortable v-slot="props" centered>
            {{ props.row.document_status }}
          </b-table-column>

          <b-table-column field="other_invitees" label="Recipients" sortable v-slot="props" centered>
            {{ props.row.other_invitees }}
          </b-table-column>

          <b-table-column field="document_action" label="Action" v-slot="props" centered>
            <b-button type="is-info"
                      @click="$router.push({name:'agentApproveDocView',params:{document_id:props.row.document_uploads_table_id, }})">
              View Document
            </b-button>
          </b-table-column>

        </b-table>

      </section>

      <section v-else>
        <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
      </section>

    </div>

  </div>
</template>

<script>

import axios from "axios";

export default {
  name:'declined-view',

  data() {
    return {
      tableRows:[], // to store pending documents
      isLoading:true,

      isPaginated: true,
      isHoverable: true,
      isBordered: false,
      isStriped: true,
      isNarrowed: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,
      stickyHeaders: true,

      columns: [

        {
          field: 'created_by',
          label: 'Created By',
          width: '200',
          centered:true,

        },
        {
          field: 'title',
          label: 'Title',
          centered:true,
        },
        {
          field: 'status',
          label: 'Status',
          centered:true,
        },
        {
          field: 'recipient',
          label: 'Recipient',
          centered:true,
        }
      ]
    }
  },

  methods:{

    getDeclinedDocumentsForAgent(){

      const comp = this
      try {

        axios.post(comp.$base_url+'/agent/getDeclinedDocumentsForAgent', {
          nicNumber : comp.$root.customerData.nicNumber,
          auth_token:comp.$root.agentAuthToken,
        })
            .then(function (response) {

              console.log("Declined Documents data ---------------")
              console.log(response)

              if(response.data.success){
                console.log("Declined documents : "+ response.data.data.inviteeDocumentList)
                comp.tableRows = response.data.data.inviteeDocumentList
                comp.isLoading = false
              }
              else{
                comp.$buefy.toast.open({
                  message: "Failed to get Declined documents",
                  type: "is-danger",
                });
              }
            })
            .catch(function (error) {
              console.log(error)

              comp.$buefy.toast.open({
                message: "Failed to get Declined documents",
                type: "is-danger",
              });
            });

      }
      catch (e) {
        comp.$buefy.toast.open({
          message: "Failed to get Declined documents",
          type: "is-danger",
        });
        console.log("Exception occurred in Customer PendingPage  getPendingDocuments() : "+e.message)
      }
    }

  },


  mounted() {
    this.getDeclinedDocumentsForAgent();
  }
}
</script>

<style scoped>
#dashboardItemTitle{
  color: #A5A6B3;
  font-weight: 600;
  font-size: 30px;
  text-align: left
}
</style>
